<template>
  <div class="container">
    <div class="fraud" v-if="fraud != '' && risktips">
      <img src="../../assets/images/bell.png" />
      <p>{{ fraud }}</p>
      <van-icon @click="risktips = false" name="cross" color="#F96A0E" size="0.13rem" />
    </div>
    <div v-if="addressVal.area" class="my_address" @click="address">
      <van-icon name="location-o" />
      <div class="my_main_address flex-ac">
        {{ addressVal.name }} {{ addressVal.mobile }}
        <img v-if="addressVal.isdefault === '1'" src="../../assets/images/default.png" />
      </div>
      <div class="address">{{ addressVal.area + '' + addressVal.address }}</div>
      <van-icon name="arrow" />
    </div>
    <div v-if="!addressVal.area" class="no_address" @click="addAddress">
      <van-icon name="plus" />
      <p>添加收货地址</p>
    </div>
    <div class="cart_pro_list">
      <div class="list">
        <pro-item v-for="(item, index) of list" :key="index" :productItem="item"></pro-item>
      </div>
      <div class="totalNumber">
        <span>共{{ totalNumber }}件</span>
        <span>
          合计：
          <span class="totalprice">¥{{ parseFloat(totalprice).toFixed(2) }}</span>
        </span>
      </div>
    </div>
    <div class="additional">
      <van-cell-group>
        <van-cell :value="'¥' + freight" value-class="f24">
          <template #title>
            <div class="integralTotal flex ai-c">
              <span>运费</span>
              <img
                v-if="freightrule"
                @click="freightruleShow = true"
                src="../../assets/images/integralrule.png"
              />
              <span class="color-6D" v-if="weight_val">&nbsp;不包邮品共{{ weight_val }}kg</span>
            </div>
          </template>
        </van-cell>
        <van-cell
          v-if="integralcount > 0"
          :title="seriesid != '' ? '使用积分数' : '使用金币数'"
          :value="integralcount + (seriesid != '' ? '积分' : '金币')"
          value-class="integral"
        />
        <van-field
          class="field"
          maxlength="45"
          v-model="remark"
          label="订单备注"
          placeholder="选填，最多45字，请先和客服协商一致"
        />
      </van-cell-group>
    </div>
    <div class="sub_bar">
      <div class="itemtxt color-FC0324">
        <span>需付款:</span>
        <span class="xprice">
          <sub>¥</sub>
          <b
            v-text="
              !isNaN(parseFloat(totalprice) + parseFloat(freight))
                ? String(parseFloat(parseFloat(totalprice) + parseFloat(freight)).toFixed(2)).slice(
                    0,
                    String(
                      parseFloat(parseFloat(totalprice) + parseFloat(freight)).toFixed(2)
                    ).indexOf('.')
                  )
                : '0'
            "
          ></b>
          <sup
            v-text="
              !isNaN(parseFloat(totalprice) + parseFloat(freight))
                ? String(parseFloat(parseFloat(totalprice) + parseFloat(freight)).toFixed(2)).slice(
                    String(
                      parseFloat(parseFloat(totalprice) + parseFloat(freight)).toFixed(2)
                    ).indexOf('.'),
                    String(parseFloat(parseFloat(totalprice) + parseFloat(freight)).toFixed(2))
                      .length
                  )
                : '.00'
            "
          ></sup>
        </span>
      </div>
      <div class="btton" @click="goNext">立即支付</div>
    </div>
    <van-dialog
      v-model="showaddress"
      class="van-flod-dialog van-address-dialog"
      title="确认信息"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="addressdialog">
        <ul>
          <li>
            <span>收货人</span>
            <p>{{ addressVal.name }}</p>
          </li>
          <li>
            <span>手机号</span>
            <p>{{ addressVal.mobile }}</p>
          </li>
          <li>
            <span>地址</span>
            <p class="ellipsis">{{ addressVal.area + '' + addressVal.address }}</p>
          </li>
          <li>
            <span>商品数量</span>
            <p class="num">{{ totalNumber }}</p>
          </li>
          <li>
            <span>应付金额</span>
            <p class="money">¥{{ (parseFloat(totalprice) + parseFloat(freight)).toFixed(2) }}</p>
          </li>
        </ul>
      </div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleAddress">修改</van-button>
        <van-button round type="danger" class="van-btn-02" @click="handlePay">去支付</van-button>
      </div>
    </van-dialog>
    <van-overlay :lock-scroll="false" :show="freightruleShow" z-index="99999">
      <div class="wrapper freightrule_box">
        <div class="block" @click.stop style="height: 70%; width: 90%">
          <div>
            <p style="padding-bottom: 0.1rem">运费规则说明</p>
            <div class="freightrule f13" v-html="freightrule"></div>
          </div>
          <van-icon @click="freightruleShow = false" name="close" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import proItem from '../common/cart_pro_item'
import { appid, isWeixin, isApp, downloadpath } from '../../assets/common/js/config'
export default {
  name: 'addOrder',
  /**
   * this.$route.query.pathType:
   * newpro:新品使用商品
   * seriescourse：健康说积分兑换商品
   * 35vipgift：35vip活动
   * */
  data() {
    return {
      productInfo: null,
      list: [],
      fraud: '',
      risktips: true,
      itemids: '',
      integralcount: 0, // 所需金币
      totalNumber: 0, // 商品数量
      totalprice: 0, // 商品总价
      addressVal: {},
      useIntegral: '', //可用金币
      totalIntegral: '', // 总金币,
      showaddress: false,
      discountaddress: 0,
      remark: '',
      freight: 0,
      seriesid: '',
      freightruleShow: false,
      freightrule: '',
      weight_val: '' /**不包邮品克重（kg） */
    }
  },
  components: {
    proItem
  },
  computed: {
    itemidsAddress: function () {
      var that = this
      if (that.addressVal && JSON.stringify(that.addressVal) != '{}') {
        var itemids = [],
          buynum = []
        var freights = 0
        freightsFn(that.list, 0)
        function freightsFn(list, type) {
          list.forEach(function (item, index) {
            itemids.push(item.skuid)
            buynum.push(item.num)
            freights = 1
          })
        }
        if (freights == 1) {
          return itemids.join(',') + '|' + that.addressVal.id + '|' + buynum.join(',')
        }
      }
      return ''
    }
  },
  watch: {
    itemidsAddress: function (val) {
      var that = this
      that.freight = 0
      var itemids = val.split('|')[0],
        addressid = val.split('|')[1],
        buynums = val.split('|')[2]
      if (
        itemids.length > 0 &&
        addressid > 0 &&
        (!this.$route.query.pathType || this.$route.query.pathType == '35vipgift')
      ) {
        var urlFreight =
          this.$ajax.calculateFreight_URL +
          '?itemid=' +
          itemids +
          '&addressid=' +
          addressid +
          '&buynum=' +
          buynums
        that.$customRequestAjax(urlFreight).then(function (res) {
          if (res.data.code === 200) {
            if (res.data.freight && parseFloat(res.data.freight) > 0) {
              that.freight = res.data.freight
            }
          }
        })
      }
    }
  },
  beforeRouteEnter: function (to, from, next) {
    if (
      from.path == '/pay' ||
      from.path == '/payResult' ||
      from.path == '/orderdetails' ||
      from.path == '/classification'
    ) {
      next(function (vm) {
        vm.$router.go(-1)
      })
    } else {
      next()
    }
  },
  mounted: function () {
    if (this.$route.query.seriesid) this.seriesid = this.$route.query.seriesid
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    goBack: function () {
      // 个人中心进入返回上一级，支付后进入返回首页
      if (this.$route.query.route) {
        this.$router.replace({ path: '/' })
      } else {
        history.go(-1)
      }
    },
    async getData() {
      var productInfo,
        url,
        skuids = [],
        buynum = []
      productInfo = JSON.parse(localStorage.getItem('productInfo'))
      this.list.push(productInfo)
      this.integralcount = productInfo.integralcount
      this.totalprice = productInfo.totalprice
      this.list =
        productInfo.productlist && productInfo.productlist.length
          ? this.list.concat(productInfo.productlist)
          : this.list
      this.list.map((item) => {
        skuids.push(item.skuid)
        buynum.push(item.num)
        this.totalNumber += parseInt(item.num)
      })
      await this.getAddress()
      if (!this.$route.query.pathType) {
        url = this.$ajax.getConfirmItems_Integralmall_URL
        url += '?item_num=' + buynum.join() + '&skuids=' + skuids.join()
        if (this.addressVal.id) url += '&addressid=' + this.addressVal.id
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            this.freightrule = res.data.freightrule || ''
            this.weight_val = res.data.weight_val || ''
            res.data.itemlist.map((item, index) => {
              let i = this.list.findIndex((listItem) => listItem.skuid === item.skuid)
              if (i > -1) {
                this.list[i] = Object.assign({}, this.list[i], item)
              } else {
                this.totalNumber += parseInt(item.num)
                this.list.push(item)
              }
            })
          }
        })
      }
    },
    getAddress() {
      return new Promise((resolve, reject) => {
        var urlAddress = this.$route.query.addressid
          ? this.$ajax.getAddressById_URL + '?id=' + this.$route.query.addressid
          : this.$ajax.getDefaultAddress_URL

        this.$customRequestAjax(urlAddress)
          .then((res) => {
            if (res.data.code === 200) {
              this.addressVal = res.data.addressdata
              resolve()
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
      })
    },
    handleAddress: function () {
      this.address()
      this.showaddress = false
    },
    handlePay: function () {
      this.goNext()
      this.showaddress = false
    },
    // 金币商品-订单提交
    goNext() {
      if (!this.addressVal.area) {
        this.$toast('请添加收货地址再提交')
        return
      }
      if (!this.discountaddress) {
        this.showaddress = true
        this.discountaddress = 1
        return
      }
      this.$toast.loading({
        mask: false,
        message: '正在提交',
        forbidClick: true,
        duration: 0
      })
      var url = this.$ajax.exchangeItem_URL,
        data,
        that = this
      data = {
        itemid: this.list[0].itemid,
        addressid: this.addressVal.id,
        remark: this.remark,
        num: this.list[0].num
      }
      if (this.$route.query.pathType == 'newpro') {
        url = this.$ajax.addOrderByPrize_URL
        data = {
          applyid: this.list[0].applyid,
          addressid: this.addressVal.id,
          remark: this.remark,
          num: this.list[0].num
        }
      } else if (
        this.$route.query.pathType == '35vipgift' ||
        this.$route.query.pathType == 'seriescourse'
      ) {
        let skuids = [],
          buynum = [],
          pathType = this.$route.query.pathType
        this.list.map((item) => {
          skuids.push(item.skuid)
          buynum.push(item.num)
        })
        url =
          pathType == '35vipgift' ? this.$ajax.addZtOrder_URL : this.$ajax.consumeItemIntegral_URL
        data = {
          skuids: skuids.join(),
          addressid: this.addressVal.id,
          remark: this.remark,
          buynum: buynum.join()
        }
        if (pathType == 'seriescourse') {
          data.seriesid = this.$route.query.seriesid
          data.integralnum = this.integralcount
        }
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.$toast.clear()
          if (this.$route.query.pathType == '35vipgift') {
            if (res.data.submitstatus == 1) {
              window.location.replace(
                '/static/wx/html/35vipgift/payresult.html?gmoeny=' + res.data.gmoeny
              )
            } else {
              this.$dialog
                .alert({
                  message: decodeURIComponent('您的产品库不足，请前往创客APP进货后购买'),
                  className: 'percen_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '去进货',
                  closeOnPopstate: false
                })
                .then(function () {
                  window.location.href = downloadpath
                })
            }
            return
          }
          that.orderid = res.data.orderid
          console.log(that.orderid)
          if (
            parseFloat(that.freight) ||
            (parseFloat(that.totalprice) && that.$route.query.integralType)
          ) {
            // 金币+钱兑换
            console.log('金币+钱兑换')
            that.getPayInfo()
          } else {
            // 金币兑换
            console.log('金币兑换')
            if (that.$route.query.pathType == 'newpro') {
              that.$router.replace({
                path: '/orderdetails',
                query: {
                  id: that.orderid,
                  receivestatus: encodeURIComponent('success')
                }
              })
            } else if (that.$route.query.pathType == 'seriescourse') {
              that.$router.replace({
                path: '/orderdetails',
                query: {
                  id: that.orderid
                }
              })
            } else {
              that.$router.replace({
                path: '/payResult',
                query: {
                  id: that.orderid,
                  money: 0,
                  payresult: encodeURIComponent('success'),
                  integralType: that.$route.query.integralType,
                  integralcount: that.integralcount,
                  yl: 0,
                  ms: 0,
                  lb: 0,
                  ylcc: 0
                }
              })
            }
          }
        } else {
        }
      })
    },
    // 获取支付信息
    getPayInfo() {
      var that = this
      this.$customRequestAjax(this.$ajax.getPayInfo_URL).then(function (res) {
        if (res.data.code === 200) {
          let info = res.data
          that.isSwitch = res.data
          that.$toast({
            message: '提交成功',
            icon: require('../../assets/images/succ.png')
          })
          if (
            isWeixin() &&
            (info.web_swiftwxpay == 1 || info.web_wxpay == 1) &&
            info.web_unionpay != 1
          ) {
            console.log('微信环境')
            that.to_cash()
          } else {
            console.log('非微信')
            sessionStorage.setItem('pay_switch', JSON.stringify(res.data))
            var arg = isApp()
            if (!arg) {
              if (that.$route.query.pathType == 'newpro') {
                that.$router.replace({
                  path: '/pay',
                  query: {
                    id: that.orderid,
                    money: !isNaN(parseFloat(that.totalprice) + parseFloat(that.freight))
                      ? parseFloat(that.totalprice) + parseFloat(that.freight)
                      : '',
                    pathType: that.$route.query.pathType || '',
                    yl: 0,
                    ms: 0,
                    lb: 0,
                    ylcc: 0
                  }
                })
              } else {
                that.$router.replace({
                  path: '/pay',
                  query: {
                    id: that.orderid,
                    money: !isNaN(parseFloat(that.totalprice) + parseFloat(that.freight))
                      ? parseFloat(that.totalprice) + parseFloat(that.freight)
                      : '',
                    integralcount: that.integralcount,
                    integralType: that.$route.query.integralType,
                    yl: 0,
                    ms: 0,
                    lb: 0,
                    ylcc: 0
                  }
                })
              }
            }
          }
        }
      })
    },
    // 检测订单状态
    to_cash() {
      var url = this.$ajax.check_order_status_URL,
        that = this
      var data = {
        oid: that.orderid
      }
      console.log('订单id', that.orderid)
      that.$customRequestAjax.post(url, data).then(function (res) {
        if (res.data && res.data.code == 200) {
          if (res.data.order_status == 1 || res.data.order_status == 2) {
            console.log('订单状态正常')
            var phpUrl
            if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
              phpUrl = that.$ajax.weixin_wxpay2_URL
              if (that.isSwitch.wx_paytype == 1) {
                phpUrl = that.$ajax.weixinnet_wxpay2_URL
              }
            } else if (that.isSwitch.web_wxpay == '1') {
              phpUrl = that.$ajax.weixin_wxpay2_URL
              if (that.isSwitch.wx_paytype == 1) {
                phpUrl = that.$ajax.weixinnet_wxpay2_URL
              }
            } else if (that.isSwitch.web_swiftwxpay == '1') {
              phpUrl = that.$ajax.swiftpass_pay_URL
            }
            let phpData = {
              openid: appid,
              orderId: that.orderid,
              type: 'integral'
            }
            that.payInfoHandle(phpUrl, phpData)
          } else {
            console.log('订单状态异常')
            that.$toast(res.data.codeinfo)
            setTimeout(function () {
              that.$router.push('/')
            }, 1000)
          }
        }
      })
    },
    // 微信支付-传参处理
    payInfoHandle(phpUrl, phpData) {
      var that = this
      that.$customRequestAjax.post(phpUrl, phpData).then(function (res) {
        if (res.data && res.data.code == 200) {
          that.$toast.clear()
          let data
          if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
            data = res.data.jsApiParameters
          } else if (that.isSwitch.web_wxpay == '1') {
            data = res.data.jsApiParameters
          } else if (that.isSwitch.web_swiftwxpay == '1') {
            data = res.data.codeinfo
          }
          that.callpay(JSON.parse(data))
        }
      })
    },
    // 支付事件处理
    callpay: function (d) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall)
        }
      } else {
        this.jsApiCall(d)
      }
    },
    jsApiCall: function (d) {
      var that = this
      WeixinJSBridge.invoke('getBrandWCPayRequest', d, function (res) {
        WeixinJSBridge.log(res.err_msg)
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          setTimeout(function () {
            if (that.$route.query.pathType == 'newpro') {
              that.$router.replace({
                path: '/orderdetails',
                query: {
                  id: that.orderid,
                  receivestatus: encodeURIComponent('success')
                }
              })
            } else {
              that.$router.replace({
                path: '/payResult',
                query: {
                  id: that.orderid,
                  money: !isNaN(parseFloat(that.totalprice)) ? parseFloat(that.totalprice) : '',
                  payresult: encodeURIComponent('success'),
                  integralcount: that.integralcount,
                  integralType: that.$route.query.integralType,
                  yl: 0,
                  ms: 0,
                  lb: 0,
                  ylcc: 0
                }
              })
            }
          }, 1000)
        } else if (
          res.err_msg == 'get_brand_wcpay_request:cancel' ||
          res.err_msg == 'get_brand_wcpay_request:fail'
        ) {
          that.$router.replace({
            path: '/payResult',
            query: {
              id: that.orderid,
              payresult: encodeURIComponent('failure'),
              yl: 0,
              ms: 0,
              lb: 0,
              ylcc: 0
            }
          })
        }
      })
    },
    address: function () {
      var query = this.$route.query
      query.addressid = this.addressVal.id
      query.type = 'submitIntegral'
      this.$router.replace({
        path: '/addresschoose',
        query: query
      })
    },
    addAddress: function () {
      var query = this.$route.query
      query.type = 'addorder'
      query.ordertype = 'submitIntegral'
      this.$router.push({
        path: '/addadd',
        query: query
      })
    }
  }
}
</script>

<style lang="scss">
.container .additional .field .van-cell__title {
  width: 0.72rem;
}
.van-cell__title span {
  font-size: 0.12rem;
}
.container .additional .van-cell__value .van-field__control,
.container .additional .van-cell__value .van-field__control::placeholder {
  font-size: 0.12rem;
  line-height: 0.25rem;
}
.van-field__control {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #323233;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  border: 0;
  resize: none;
}
.freightrule_box {
  overflow: hidden;
}
.freightrule_box .block > div {
  height: 80%;
  position: relative;
  background: #ffffff;
  padding: 0.1rem 0;
  overflow: hidden;
}
.freightrule_box .block p {
  margin: 0;
}
.freightrule_box .block .freightrule {
  padding-top: 0;
  height: 93%;
  overflow-y: auto;
  text-align: left;
  p {
    text-align: left;
  }
}
</style>
<style scoped lang="scss">
.f24 {
  font-size: 24rpx;
}
.container {
  padding-bottom: 0.6rem;
  .fraud {
    display: flex;
    align-items: center;
    background: #fefceb;
    margin: 0.1rem 0.11rem;
    padding: 0.08rem;
    border-radius: 0.04rem;
    img {
      width: 0.17rem;
      height: 0.17rem;
      padding: 0.01rem 0.03rem 0.02rem 0.02rem;
    }
    p {
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(249, 106, 14, 1);
      line-height: 0.17rem;
      margin-left: 0.06rem;
      margin-right: 0.08rem;
    }
  }
  .my_address {
    margin: 0.11rem;
    background: #fff;
    border-radius: 0.04rem;
    padding: 0.15rem 0;
    padding-left: 0.47rem;
    position: relative;
    .my_main_address {
      font-size: 0.16rem;
      line-height: 0.22rem;
      color: #222222;
      font-weight: 600;
      img {
        width: 0.2rem;
        height: 0.12rem;
        margin-left: 0.05rem;
      }
    }
    .address {
      font-size: 0.12rem;
      line-height: 0.17rem;
      color: #999;
      margin-top: 0.04rem;
      padding-right: 0.3rem;
      height: 0.34rem;
      overflow: hidden;
    }
    .van-icon-location-o {
      position: absolute;
      top: 0.35rem;
      left: 0.17rem;
      font-size: 0.19rem;
    }
    .van-icon-arrow {
      position: absolute;
      top: 0.35rem;
      right: 0.15rem;
      font-size: 0.16rem;
      color: #1d1e1e;
    }
  }
  .no_address {
    padding: 0.13rem 0.15rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.04rem;
    font-size: 0;
    margin: 0.11rem;
    .van-icon-plus {
      font-size: 0.15rem;
      line-height: 0.21rem;
      color: rgba(29, 30, 30, 1);
      top: 0.02rem;
    }
    p {
      display: inline-block;
      font-size: 0.15rem;
      font-weight: 400;
      color: rgba(29, 30, 30, 1);
      line-height: 0.21rem;
      margin-left: 0.08rem;
    }
  }
  .cart_pro_list {
    border-radius: 0.04rem;
    background: #fff;
    margin: 0.1rem 0.11rem;
    padding: 0.1rem 0.15rem;
    .list {
      padding-bottom: 0.2rem;
      font-size: 0.14rem;
      position: relative;
    }
    .list:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #d8d8d8;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .totalNumber {
      font-size: 0.12rem;
      line-height: 0.45rem;
      text-align: right;
      color: #3d3d3d;
      .totalprice {
        color: #fc0324;
        font-size: 0.16rem;
      }
    }
  }
  .additional {
    border-radius: 0.04rem;
    background: #fff;
    margin: 0.1rem 0.11rem;
    padding: 0.15rem 0;
    .van-cell:not(:last-child)::after,
    .van-hairline--top-bottom::after {
      border: 0;
    }
    .txt {
      font-size: 0.12rem;
      color: #333333;
      flex: auto;
    }
    .integral {
      color: #c58b53;
    }
  }
  .sub_bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.49rem;
    font-size: 0.14rem;
    background: #fff;
    border-top: solid 1px rgba(0, 0, 0, 0.25);
    .itemtxt {
      position: absolute;
      top: 0.11rem;
      left: 0.11rem;
      font-size: 0.12rem;
      color: #222222;
      width: 60%;
      display: flex;
      align-items: center;
      .xprice {
        font-size: 0;
      }
      b {
        font-size: 0.16rem;
        font-weight: 500;
      }
      sub {
        font-weight: normal;
        font-size: 0.12rem;
        vertical-align: baseline;
      }
      sup {
        font-size: 0.11rem;
        vertical-align: baseline;
        font-weight: 500;
      }
    }
    .btton {
      position: absolute;
      top: 0.05rem;
      right: 0.11rem;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      border-radius: 0.19rem;
      font-size: 0.16rem;
      width: 31%;
      line-height: 0.38rem;
      text-align: center;
      color: #fff;
    }
  }
  .coupon {
    .coupon_item {
      position: relative;
      .coupon_info {
        background: url('../../assets/images/couponbg.png') center center no-repeat;
        background-size: 100% 100%;
        min-height: 1.07rem;
        width: 3.45rem;
        margin: 0 auto;
        margin-top: 0.1rem;
        position: relative;
        .f1 {
          background: #fbf1df;
          font-size: 0.12rem;
          text-align: center;
          width: 29.2%;
          float: left;
          span:nth-child(1) {
            display: block;
            font-size: 0.37rem;
            color: #b1243d;
            font-weight: 600;
            line-height: 0.52rem;
            margin-top: 0.16rem;
            &:before {
              content: '￥';
              font-size: 0.15rem;
              font-weight: 600;
              color: rgba(177, 36, 61, 1);
              line-height: 0.21rem;
            }
          }
          span:nth-child(2) {
            color: #d43854;
            font-size: 0.12rem;
            transform: scale(0.85);
            text-align: center;
          }
        }
        .f2 {
          float: left;
          position: relative;
          margin-left: 0.1rem;
          min-height: 1.07rem;
          width: 60%;
          overflow: hidden;
          span:nth-child(1) {
            display: block;
            font-size: 0.15rem;
            line-height: 0.21rem;
            color: #292929;
            font-weight: 600;
            margin-top: 0.23rem;
          }
          span:nth-child(2) {
            label {
              transform: scale(0.8);
              display: block;
              margin-left: -10%;
            }
            font-size: 0.12rem;
            line-height: 0.18rem;
            color: #6b6b6b;
            display: block;
            margin-top: 0.08rem;
          }
        }
        .f3 {
          position: absolute;
          top: 0.47rem;
          right: 0.1rem;
          font-size: 0.12rem;
          color: #fff;
          padding: 0.05rem 0.12rem;
          min-width: 0.6rem;
          text-align: center;
          background: #fc0324;
          border-radius: 0.14rem;
        }
        .f3.active {
          background: #dddddd;
        }
        .coupon_tit {
          font-size: 0.12rem;
          color: #999999;
          left: 0;
          position: absolute;
          bottom: 0.05rem;
          width: 98%;
          padding-left: 29.2%;
          .tit_info {
            position: relative;
            padding-left: 0.1rem;
            .tit {
              float: left;
              transform: scale(0.85);
              margin-left: -0.03rem;
            }
            .van-icon {
              float: right;
              transform: scale(0.85);
            }
          }
        }
      }
      .coupon_desc {
        font-size: 0.12rem;
        line-height: 0.17rem;
        color: #848483;
        width: 3.45rem;
        margin: 0 auto;
        border: solid 1px rgba(237, 214, 173, 0.5);
        border-top: 0;
        padding: 0.06rem 0.1rem;
      }
    }
    .coupon_btn {
      width: 3.53rem;
      height: 0.43rem;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      border-radius: 0.25rem;
      text-align: center;
      font-size: 0.17rem;
      line-height: 0.24rem;
      color: #fff;
      line-height: 0.43rem;
      margin: 0.1rem auto;
      margin-top: 0.2rem;
      span {
        font-size: 0.13rem;
      }
    }
  }
  .coupon_name {
    padding: 0.17rem 0;
    position: relative;
    font-size: 0.14rem;
    color: #222222;
    text-align: center;
    font-weight: 400;
    img {
      position: absolute;
      right: 0.15rem;
      top: 0.17rem;
      width: 0.2rem;
      height: 0.2rem;
    }
  }
  .integralTotal {
    img {
      width: 0.16rem;
      height: 0.16rem;
      margin-left: 0.02rem;
    }
  }
}
.van-flod-dialog {
  width: 70%;
  // display: none;
  &.van-address-dialog {
    width: 84%;
    .addressdialog {
      padding: 0.15rem 0.2rem 0;
      ul {
        li {
          margin-top: 0.15rem;
          overflow: hidden;
          width: 100%;
          color: #444444;
          font-size: 0.14rem;
          font-weight: 400;
          span {
            float: left;
            max-width: 30%;
          }
          p {
            float: right;
            max-width: 70%;
            &.ellipsis {
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            &.num,
            &.money {
              font-weight: 600;
            }
            &.money {
              color: #fc0324;
            }
          }
        }
      }
    }
  }
  .floddialog {
    padding: 0.3rem 0.1rem;
    padding-bottom: 0.1rem;
    text-align: center;
    font-size: 0.14rem;
    line-height: 0.2rem;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.22rem 0.19rem;
    .van-btn-01,
    .van-btn-02 {
      width: 1.04rem;
      line-height: 0.32rem;
      height: 0.32rem;
      border-radius: 0.16rem;
    }
    .van-btn-01 {
      color: rgba(252, 3, 36, 1);
      border: 1px solid rgba(252, 3, 36, 1);
    }
    .van-btn-02 {
      background-color: #fc0324;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/integral/addOrderIntegral.vue